import type { Meta, StoryFn } from '@storybook/react';
import { useMemo, useState } from 'react';
import type { BaseEmoji } from 'emoji-mart';

import { EmojiPicker, EmojiContext, Flex, Input } from '@pega/cosmos-react-core';
import type { EmojiPickerProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/EmojiPicker',
  component: EmojiPicker,
  args: {
    showFooter: false,
    emojiSize: 24,
    perLine: 9
  },
  argTypes: {
    showFooter: { control: { type: 'boolean' } },
    emojiSize: { control: { type: 'number' } },
    perLine: { control: { type: 'number' } }
  }
} as Meta;

export const EmojiPickerDemo: StoryFn<EmojiPickerProps> = (args: EmojiPickerProps) => {
  const [value, setValue] = useState<string>('');

  const onEmojiSelect = (emoji: BaseEmoji) => {
    setValue(curr => `${curr}${emoji.native}`);
  };

  return (
    <Flex container={{ direction: 'column' }}>
      <Input value={value} />
      <EmojiPicker
        showFooter={args.showFooter}
        emojiSize={args.emojiSize}
        perLine={args.perLine}
        onSelect={onEmojiSelect}
      />
    </Flex>
  );
};

export const EmojiPickerExcludeDemo: StoryFn<EmojiPickerProps> = (args: EmojiPickerProps) => {
  const [value, setValue] = useState<string>('');

  const onEmojiSelect = (emoji: BaseEmoji) => {
    setValue(curr => `${curr}${emoji.native}`);
  };

  return (
    <Flex container={{ direction: 'column' }}>
      <Input value={value} />
      <EmojiPicker
        exclude={['recent', 'people', 'foods', 'activity', 'flags']}
        showFooter={args.showFooter}
        emojiSize={args.emojiSize}
        perLine={args.perLine}
        onSelect={onEmojiSelect}
      />
    </Flex>
  );
};

export const CustomEmojiSet: StoryFn<EmojiPickerProps> = (args: EmojiPickerProps) => {
  const [value, setValue] = useState<string>('');

  const onEmojiSelect = (emoji: BaseEmoji) => {
    setValue(curr => `${curr}${emoji.native}`);
  };

  const ctx = useMemo(
    () =>
      ({
        set: 'google',
        spriteSrcResolver: () =>
          'https://unpkg.com/emoji-datasource-google@5.0.1/img/google/sheets-clean/32.png'
      }) as const,
    []
  );

  return (
    <EmojiContext.Provider value={ctx}>
      <Flex container={{ direction: 'column' }}>
        <Input value={value} />
        <EmojiPicker
          showFooter={args.showFooter}
          emojiSize={args.emojiSize}
          perLine={args.perLine}
          onSelect={onEmojiSelect}
        />
      </Flex>
    </EmojiContext.Provider>
  );
};
